import { render, staticRenderFns } from "./SpdRecordsHistory.vue?vue&type=template&id=6542ad24&"
import script from "./SpdRecordsHistory.vue?vue&type=script&lang=js&"
export * from "./SpdRecordsHistory.vue?vue&type=script&lang=js&"
import style0 from "./SpdRecordsHistory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports